<template>
  <info-bar-text v-if="isEssentialPortal" :text="$t('impersonateModeEssentialShop')" />
  <template v-else>
    <info-bar-text
      v-if="impersonationStatus.relation == Relation.BRANCH"
      :text="$t('subsidiaryMode', [impersonationStatus.customer])"
    />
    <info-bar-text v-else :text="$t('impersonateMode', [impersonationStatus.customer])" />
  </template>
</template>

<script setup lang="ts">
import InfoBarText from '@/components/info-bar/InfoBarText.vue'
import { isEssentialPortal } from '@/helpers'
import { ImpersonationStatus, Relation } from '@/types/index'
import { PropType } from 'vue'

defineProps({
  impersonationStatus: {
    type: Object as PropType<ImpersonationStatus>,
    required: true
  }
})
</script>
